import { useNavigate } from "react-router-dom";
import {
  AdminTemplate,
  MasterPassListingTable,
} from "../../components";

export const MasterPassList= () => {
  const navigate = useNavigate();

  const handleAddButton = () =>
    navigate("/merchant-management/masterpass-identification-detail");
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Masterpass Üye İşyeri Listeleme",
        onClickAddButton: handleAddButton,
      }}
    >
      <MasterPassListingTable />
    </AdminTemplate>
  );
};
